import { DataBean } from "../DataBean";

export class OrderToFinished extends DataBean {


    public async getProductionOrderToFinishedProductCatalog(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductionOrderToFinishedProductCatalog_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }

}